import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CheckoutService } from '@checkout-v2/feature';
import { CustomOrder } from '@order/const';
import { UrlModule } from '@spartacus/core';
import { CurrentProfile } from '@user/const';
import { CurrentProfileService } from '@user/feature';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-title',
  templateUrl: './order-confirmation-info-title.component.html',
  styleUrls: ['./order-confirmation-info-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, UrlModule],
})
export class OrderConfirmationInfoTitleComponent implements OnInit {
  currentProfile$: Observable<CurrentProfile>;
  order$: Observable<CustomOrder>;

  constructor(
    private checkoutService: CheckoutService,
    private currentProfileService: CurrentProfileService,
  ) {}

  ngOnInit(): void {
    this.currentProfile$ = this.currentProfileService.get();
    this.order$ = this.checkoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
